import { render } from "./DetailedProjectOverdue.vue?vue&type=template&id=e1463984&scoped=true"
import script from "./DetailedProjectOverdue.vue?vue&type=script&lang=js"
export * from "./DetailedProjectOverdue.vue?vue&type=script&lang=js"

import "./DetailedProjectOverdue.vue?vue&type=style&index=0&id=e1463984&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1463984"]])

export default __exports__